import { useLocation } from 'react-router-dom'
import { parse } from 'query-string'
import { useMemo } from 'react'

function useParseQueryString() {
  const searchParams = new URLSearchParams(window.location.search)
  const serialisedSearchParams = searchParams.toString()

  const { search: routerSearch } = useLocation()

  return useMemo(
    () => parse(window.location.hash ? routerSearch : serialisedSearchParams),
    [routerSearch, serialisedSearchParams],
  )
}

export default useParseQueryString
